<template>
  <div id="my-popup" @click="myclose">
    <van-loading type="spinner" color="#ffffff" />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "my-popup",
  computed: mapState(["isGeting"]),
  props: ["canclose"],
  data() {
    return {
      dom: ""
    };
  },
  mounted() {
    this.initPopup();
  },
  watch: {
    isGeting(v) {
      if (v) {
        this.showPopup();
      } else {
        this.hidePopup();
      }
    }
  },
  methods: {
    initPopup() {
      const domobj = document
        .getElementsByClassName("views")[0]
        .getClientRects();
      const _my = document.getElementById("my-popup");
      this.dom = _my;
      _my.style.width = Math.round(domobj[0].width + 1) + "px";
      _my.style.height = Math.round(domobj[0].height) + "px";
      _my.style.top = Math.round(domobj[0].top) + "px";
      _my.style.left = Math.round(domobj[0].left) + "px";
    },
    hidePopup() {
      this.dom.style.display = "none";
    },
    showPopup() {
      this.dom.style.display = "flex";
    },
    myclose() {
      if (this.canclose) {
        this.show = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/index";
#my-popup {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  position: fixed;
  z-index: 9999;
}
</style>
